import React, { useState, useEffect, useRef } from "react";
import "../../styles/Builder.css";
import * as Constants from "common/constants";
import jwtDecode from "jwt-decode";
import { Card } from "react-bootstrap";
import { useParams, useNavigate, useLocation } from "react-router-dom";
//import ToastifyNotification from "../toastifyNotification/ToastifyNotification";
import { toast } from "react-toastify";
import { refreshWorkflowCounts } from "../workflow/WorkflowHelper";
import LanguageGate from "components/common/LanguageGate";
import LoaderIcon from "components/custom/Preloader";
import {
	getExecutionLocalVariables,
	SubmitWorkflowData,
} from "components/workflow/WorkflowHelper";
import Formioform from "./FormioForm";
import FormioWizard from "./FormioWizard"
import queryString from "query-string";
//import db from "indexedDB";

import { useTranslation } from "react-i18next";
import "components/forms/custom";
import useAuth from "hooks/useAuth";

const FVR_CACHE_KEY = "fvr:lastState";
let onlineHandler = null;

function FormViewRenderer() {
	const navigate = useNavigate();
	const location = useLocation();
	const state = location.state;
	const [form, setForm] = useState(null);

	const [jsonSchema, setSchema] = useState([]);
	const [query, setQuery] = useState("");
	const [formName, setFormName] = useState("");
	const [showAlert, setShowAlert] = useState(false);
	const [submitted, setSubmitted] = useState(false);
	const [showNotification, setShowNotification] = useState(false);
	const [showPreloader, setshowPreloader] = useState(false);
	const [submissionData, setSubmissionData] = useState({});
	const [showFailAlert, setShowFailAlert] = useState(false);
	const [alertmessage, setAlertMessage] = useState("");
	const [nextPage, setNextPage] = useState(false);
    const keycloakAuth = useAuth();

	const { index } = useParams();
	//const [t, i18n] = useTranslation();
	const queryParams = queryString.parse(location.search);

	const didSelfRestoreRef = useRef(false);


	useEffect(() => {
		try {
			if (state != null) {
				if (state.data?.scheduled === "true") {
					state.data.settings.data.isEditable = true;
				} else if (state.data?.settings?.data) {
					state.data.settings.data.initiallyEnabled = true;
				}
				setForm(state.data);

				sessionStorage.setItem(FVR_CACHE_KEY, JSON.stringify(state.data));
			} else {
				const cached = sessionStorage.getItem(FVR_CACHE_KEY);

				if (cached && !didSelfRestoreRef.current) {
					didSelfRestoreRef.current = true;

					const restored = JSON.parse(cached);
					navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: { data: restored } });
					return;
				}
			}

			if (submitted) {
				setSubmitted(false);
				window.location.reload(false);
			}
		} catch (e) {
			console.error(e);
			navigate("/");
		}
	}, [location.key, navigate, state, submitted]);

	/*useEffect(() => {

		if (onlineHandler) {
			window.removeEventListener("online", onlineHandler);
		}

		onlineHandler = async () => {
			const encryptStorage1 = "";
			const tempSubmissionData = await db.submission_data.toArray();

			for (let i = 0; i < tempSubmissionData.length; i++) {
				const isLastIteration = i === tempSubmissionData.length - 1;

				const submission = tempSubmissionData[i];
				// let onlineStatusFormData = await db.pending_tasks.get(parseInt(JSON.parse(submission.submissionData).index, 10));
				// onlineStatusFormData = JSON.parse(onlineStatusFormData.pendingTasks);

				const { index, ...submissionData } = JSON.parse(submission.submissionData);

				 if (isLastIteration) {
					await db.table("submission_data").clear();
					await db.table("pending_tasks").clear();
				} 

				await handleTaskSubmit(
					submissionData,
					onlineStatusFormData,
					setSubmitted,
					setshowPreloader,
					state.data,
					location,
					setShowNotification,
					queryParams,
					navigate,
					state,
					keycloakAuth,
				//	t,
					isLastIteration,
					setNextPage
				);

				await new Promise((resolve) => setTimeout(resolve, 2000));
			}
		};
		

		window.addEventListener("online", onlineHandler);
	}, []);*/

	if (!form) {
		return (
			<div className="container">
				<Card className="p-4">
					<LoaderIcon />
				</Card>
			</div>
		);
	}

	return (
		<div className="container">
			<Card className="p-4">
				{showPreloader && <LoaderIcon />}
				<LanguageGate fallback={null}>
					<Formioform
						form={form}
						onSubmit={(data) =>
							handleTaskSubmit(data, null, setSubmitted, setshowPreloader, form, location, setShowNotification, queryParams, navigate, state, keycloakAuth, "", false, setNextPage)
						}
						submission={{ data: form.settings.data }}
						nextPage={nextPage}
						state={state?.data}
					/>
				</LanguageGate>
				{/*showNotification && <ToastifyNotification show={showNotification} />*/}
			</Card>
		</div>
	);
}

export const handleTaskSubmit = async (
	submission,
	onlineStatusFormData,
	setSubmitted,
	setshowPreloader,
	form,
	location,
	setShowNotification,
	queryParams,
	navigate,
	state,
	keycloakAuth,
	//t,
	isLastIteration,
	setNextPage
) => {
	 if (!keycloakAuth?.token) return null;

	/* await db.current_workflow_step.clear;
	await db.temp_form_data.clear; */
	localStorage.removeItem(Constants.CurrentWorkflowStep);

	  let userId = null;
	  try {
		userId = jwtDecode(keycloakAuth.token)?.sub;
	  } catch (e) {
		console.error("Invalid token", e);
	  }
	const loggedInUser = userId;
	let companyType = null;
	let step = null;
	let formKey = null;
	let processInstanceID = null;
	let creationDate = null;
	let modificationDate = null;

	if (location?.state != null) {
		companyType = location.state.companyType;
		step = location.state.data.step;
		formKey = location.state.data.formKey;
		processInstanceID = location.state.data.processInstanceId;
		creationDate = location.state.data.creationDate;
		modificationDate = location.state.data.modificationDate;
	}

	submission.data.formKey = formKey;
	submission.data.step = step;
	submission.data.processInstanceId = processInstanceID;

	if (!navigator.onLine) {
		toast.success("Form is being submitted offline. It will be processed when you go online.", {
			position: "top-right",
			autoClose: 3000,
		});

		submission.index = queryParams.index;
		//db.submission_data.add({ submissionData: JSON.stringify(submission) });

		await refreshWorkflowCounts();
		navigate("/userTasks");
		return;
	} else {
		setshowPreloader(true);
		toast.success("Form is being Submitted. Please Wait a moment", {
			position: "top-right",
			autoClose: 3000,
		});


		//const companyId = encryptStorage1.getItem(Constants.SelectedCompany);
		const lang = localStorage.getItem("i18nextLng");
		const submitedWorkflow = await SubmitWorkflowData(loggedInUser, submission.data, form ?? onlineStatusFormData, "companyId", lang,keycloakAuth.token);
		setshowPreloader(false);

		let executionLocalVariables = "";
		if (form?.executionId) {
		//	executionLocalVariables = await getExecutionLocalVariables(form?.executionId,keycloakAuth.token);

			if (executionLocalVariables?.redirectionPage) {
				navigate("/" + executionLocalVariables?.redirectionPage.value);
				return;
			}
		}

		if (submitedWorkflow?.status === 2) {
			navigate("/form_view_renderer", {
				replace: true,
				state: {
					data: JSON.parse(submitedWorkflow.message),
					assignee: loggedInUser,
				},
			});
			setNextPage(true);
			return;
		}
	}

	await refreshWorkflowCounts();
	navigate("/userTasks");
	return;
};

export default FormViewRenderer;
 